import React, { useCallback, useEffect, useState } from 'react';
import StoreCategory from '../components/StoreCategory';
import { PartnersCategoryListItemTypes } from '@typedef/components/Partners/partners.types';
import {
  apiRoute,
  BasicApiResponse,
  requestGet,
  requestSecureDelete,
  requestSecurePatch,
  requestSecurePost,
} from '@libs/api/api';
import { alertMessage } from '@libs/alertMessage';
import useToken from '@hooks/store/useToken';

const StoreCategoryContainer = () => {
  const { getAccessToken } = useToken();
  const [list, setList] = useState<PartnersCategoryListItemTypes[]>([]);

  const [updateIdx, setUpdateIdx] = useState(-1);
  const [name, setName] = useState('');

  const [newName, setNewName] = useState('');

  const [addPopupVisible, setAddPopupVisible] = useState(false);

  const onAddClicked = useCallback(() => {
    setAddPopupVisible(true);
  }, []);

  const loadList = useCallback(async () => {
    const { data, config } = await requestGet<PartnersCategoryListItemTypes[]>(
      apiRoute.partners.tags.getTags,
      {},
    );

    if (config.status === 200) {
      setList(data);
    } else {
      alertMessage('목록을 불러오지 못했습니다');
    }
  }, []);

  const onChangeNameDoneBtnClicked = useCallback(
    async (item: PartnersCategoryListItemTypes) => {
      // TODO : Need to Implement Contents

      const {
        data,
        config: { status },
      } = await requestSecurePatch<{}>(
        apiRoute.store.updateTargetTag + item.targetTagUid,
        {},
        { name },
        getAccessToken()!,
      );

      if (status !== 202) {
        alertMessage('샵 카테고리 수정에 실패했습니다.');
        return;
      }

      setList((prev) => {
        const clone = [...prev];
        clone[updateIdx] = { ...item, name };
        return clone;
      });
      setUpdateIdx(-1);
    },
    [name, updateIdx],
  );

  const onAddNewCategoryClicked = useCallback(async () => {
    const { data, config } = await requestSecurePost<BasicApiResponse<{}>>(
      apiRoute.partners.tags.addTags,
      {},
      { name: newName },
      getAccessToken()!,
    );

    console.log(data, config);
    if (config.status !== 201) return;
    setNewName('');
    setAddPopupVisible(false);
    loadList();
  }, [newName]);

  const onDeleteClicked = useCallback(
    async (item: PartnersCategoryListItemTypes, idx: number) => {
      const {
        data,
        config: { status },
      } = await requestSecureDelete<BasicApiResponse<{}>>(
        apiRoute.store.deleteTargetTag + item.targetTagUid,
        {},
        getAccessToken()!,
      );

      if (status !== 202) {
        alertMessage('샵 카테고리 삭제에 실패했습니다.');
        return;
      }

      setList((prev) => {
        const clone = [...prev];
        clone.splice(idx, 1);
        return clone;
      });
    },
    [],
  );

  useEffect(() => {
    loadList();
  }, []);

  return (
    <StoreCategory
      list={list}
      addPopupVisible={addPopupVisible}
      onAddClicked={onAddClicked}
      updateIdx={updateIdx}
      setUpdateIdx={setUpdateIdx}
      setName={setName}
      setNewName={setNewName}
      onChangeNameDoneBtnClicked={onChangeNameDoneBtnClicked}
      onAddNewCategoryClicked={onAddNewCategoryClicked}
      onDeleteClicked={onDeleteClicked}
    />
  );
};

export default StoreCategoryContainer;
